import SearchRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/SearchRequest";
import IFilterModel from "../IFilterModel";
import moment from "moment";
import SearchRewardRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Reward/SearchRewardRequest";

export class RewardFilterModel implements IFilterModel {
  search: string = "";
  trigger: number = 0;
  dateFrom: Date = null;
  dateTo: Date = null;

  resetToDefault() {
    this.search = "";
    this.dateFrom = null;
    this.dateTo = null;
  }

  toSearchRequest(): SearchRequest[] {
    const res = new Array<SearchRequest>();
    if (this.dateFrom) {
      const range = new SearchRequest({
        FieldName: "Created",
        SearchFrom: moment(this.dateFrom).format("YYYY-MM-DD"),
      });
      res.push(range);
      if (this.dateTo) {
        range.SearchTo = moment(this.dateTo).format("YYYY-MM-DD");
      }
    }
    return res;
  }

  toFilterRequest(): SearchRewardRequest {
    const res = new SearchRewardRequest({
      Name: this.search,
      Trigger: this.trigger ? this.trigger : null
    });

    res.Search = this.toSearchRequest();
    return res;
  }
}
